<template>
  <div class="inside-table">
    <main class="list-table mt-5">
      <div class="row">
        <div class="col-md-12 text-right">
          <div class="buttons">
            <button
              class="btn-enter mr-5"
              @click="openModal"
              v-if="isHappening"
            >{{ $t("events.listEvents.enterManualBtn") }}</button>

            <button
              @click="downloadTable"
              class="btn-download"
            >{{ $t("events.listEvents.donwloadBtn") }}</button>
          </div>
        </div>
      </div>
      <v-server-table
        :columns="table_options.columns"
        :options="table_options.options"
        ref="userTable"
      ></v-server-table>
    </main>
    <Modal v-if="modalActive" @closeModal="closeModal" :class="alertModal ? 'modal-alert' : ''">
      <template #header>
        <h6
          class="modal-title bolded"
          v-if="!alertModal"
        >{{ $t("events.listEvents.tabs.enterEvent.modal.title") }}</h6>
        <h6 v-if="alertModal" class="modal-title bolded">{{ $t("events.guest.modal.atention") }}</h6>
      </template>
      <template>
        <p v-if="!alertModal">{{ $t("events.listEvents.tabs.enterEvent.modal.body-text") }}</p>
        <p v-if="alertModal">{{ $t("events.listEvents.tabs.enterEvent.modal.markAsInsideAlert") }}</p>
        <p v-if="alertModal">{{ $t("events.listEvents.tabs.enterEvent.modal.sureAlert") }}</p>
        <div class="inputs-form" v-if="!alertModal">
          <div class="input-div mt-3">
            <label class="bolded">
              1.{{
              $t("events.listEvents.tabs.enterEvent.modal.nameOfGuest")
              }}
            </label>
            <input
              type="text"
              :placeholder="
                $t(
                  'events.listEvents.tabs.enterEvent.modal.nameOfGuestPlaceholder'
                )
              "
              v-model="enteredNameGuest"
            />
          </div>
          <div class="input-div mt-5 mb-5">
            <label class="bolded">
              2.{{
              $t("events.listEvents.tabs.enterEvent.modal.emailOfGuest")
              }}
            </label>
            <input
              type="text"
              :placeholder="
                $t(
                  'events.listEvents.tabs.enterEvent.modal.emailOfGuestPlaceholder'
                )
              "
              v-model="enteredEmailGuest"
            />
          </div>
        </div>
      </template>
      <template #footer>
        <div class="controls">
          <span class="control cancel-btn mr-4" @click="closeModal">
            {{
            $t("map.benefits.list.modal.cancel")
            }}
          </span>
          <button
            type="control button"
            class="control continue"
            v-if="!alertModal"
            @click="alertModalOpen"
            :disabled="enteredNameGuest === '' || enteredEmailGuest === ''"
          >{{ $t("events.listEvents.tabs.enterEvent.modal.continue") }}</button>
          <span
            type="control button"
            class="control continue"
            v-if="alertModal"
            @click="enterManuallyGuest"
          >{{ $t("events.listEvents.tabs.enterEvent.modal.entered") }}</span>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import API_SERVICE from "@/lib/api/Events.js";
const api = new API_SERVICE();
const Modal = () => import("@/components/Modal");
import Json2Csv from "vue-json-to-csv";

export default {
  components: {
    Modal,
    Json2Csv
  },
  props: ["isHappening"],

  data() {
    return {
      items: null,
      folio: "",
      page: 0,
      modalActive: false,
      enteredNameGuest: "",
      enteredEmailGuest: "",
      alertModal: false,
      csvData: null,
      dictionary: {
        name: this.$t("events.listEvents.tabs.enterEvent.table.headings.name"),
        lastName: this.$t(
          "events.listEvents.tabs.enterEvent.table.headings.lastName"
        ),
        mothersLastName: this.$t(
          "events.listEvents.tabs.enterEvent.table.headings.mothersLastName"
        ),
        code: this.$t("events.listEvents.tabs.enterEvent.table.headings.code"),
        companyEmail: this.$t(
          "events.listEvents.tabs.enterEvent.table.headings.email"
        ),
        dateAndHour: this.$t(
          "events.listEvents.tabs.enterEvent.table.headings.dateAndHour"
        )
      }
    };
  },

  methods: {
    async downloadTable() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        let id = this.$route.params.id;
        const resp = await api.downloadEventTable(id, "inside");
        let anchor = document.createElement("a");
        anchor.href = resp.url;
        anchor.target = "_blank";
        anchor.click();
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    openModal: function() {
      this.modalActive = true;
    },
    closeModal: function() {
      this.modalActive = false;
      this.alertModal = false;
      this.enteredEmailGuest = "";
      this.enteredNameGuest = "";
    },
    alertModalOpen() {
      this.alertModal = true;
    },
    async enterManuallyGuest() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        let params = {
          guestName: this.enteredNameGuest,
          email: this.enteredEmailGuest
        };
        let id = this.$route.params.id;
        const resp = await api.enterManually(params, id);
        this.$refs.userTable.refresh();
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
        this.closeModal();
      }
    }
  },
  computed: {
    userTable: function() {
      return this.$refs.userTable;
    },
    table_columns: function() {
      // if (this.users) return ['select', ...Object.keys(this.users[0])];
      // return null;
      return [
        "name",
        "lastName",
        "mothersLastName",
        "code",
        "companyEmail",
        "dateAndHour"
      ];
    },
    table_headings: function() {
      if (this.table_columns) {
        const headings = {};
        this.table_columns.forEach(column => {
          headings[column] = this.$t(
            `events.listEvents.tabs.enterEvent.table.headings.${column}`
          );
        });
        return headings;
      }
      return null;
    },
    table_filters: function() {
      return this.table_columns.filter(column => column !== "markAsEnter");
    },
    table_options: function() {
      return {
        columns: this.table_columns,
        options: {
          columnsDropdown: true,
          filterByColumn: true,
          headings: this.table_headings,
          filterable: this.table_filters,
          resizableColumns: false,
          sortable: [],
          perPage: 10,
          texts: {
            filterBy: "{column}",
            columns: this.$t("users.search.table.column_toggler")
          },

          requestAdapter: function(data) {
            const queries = {};
            queries.page = data.page - 1;
            queries.limit = data.limit;
            queries.query = data.query;
            if (queries.query.companyEmail) {
              queries.query.email = queries.query.companyEmail;
            }
            queries.filter = "inside";
            return queries;
          },
          requestFunction: async function(data) {
            this.$store.commit("global/SET_LOADING", true);
            try {
              let id = this.$route.params.id;
              const resp = await api.getGuestsByStatus(data, id);
              for (let index = 0; index < resp.users.result.length; index++) {
                if (resp.users.result[index].ticketType === "external") {
                  resp.users.result[index].companyEmail =
                    resp.users.result[index].email;
                  resp.users.result[index].name = this.$t(
                    "events.listEvents.tabs.enterEvent.table.externalGuest"
                  );
                  resp.users.result[index].lastName = this.$t(
                    "events.listEvents.tabs.enterEvent.table.externalGuest"
                  );
                  resp.users.result[index].mothersLastName = this.$t(
                    "events.listEvents.tabs.enterEvent.table.externalGuest"
                  );
                }
              }
              this.$store.commit("global/SET_LOADING", false);
              this.$store.commit(
                "global/SET_RESP",
                resp.users.busyPlacesResult
              );
              return resp;
            } catch (error) {
              this.$store.commit("global/SET_LOADING", false);
              throw error;
            }
          },
          responseAdapter: function(response) {
            return {
              data: response.users.result,
              count: response.users.subTotal
            };
          }
        }
      };
    },

    appLang: function() {
      return this.$store.getters["settings/currentLang"];
    }
  }
};
</script>

<style lang="scss">
#user-search {
  .pull-right {
    float: none;
  }
  .VueTables .dropdown {
    margin: 1rem 0;
  }
  .VueTables .dropdown > button {
    @extend %audi;
    color: $black;
    background-color: transparent;
    border: 1px solid $black;
    border-radius: 0;
    padding: 5px 10px;
  }
  .VueTables .dropdown .dropdown-menu {
    padding: 1rem;
    a {
      color: $black;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    a > input {
      margin-right: 0.5rem;
    }
    input[type="checkbox"][value="select"] {
      display: none;
    }
  }
  .VueTables__table.table {
    min-width: 100%;
    width: max-content;
  }
  .VueTables__table .select-column {
    position: sticky;
    left: 0;
    text-align: center;
    &:after {
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      background-color: #f2f2f2;
      top: 0;
      left: 0;
      border-collapse: collapse;
    }
  }
  .VueTables__table .select-column > * {
    position: relative;
    z-index: 1;
  }
  .table-striped tbody tr:nth-of-type(odd) > .select-column {
    &:after {
      background-color: #e6e6e6;
    }
  }
  .VueTables__table .id-column {
    max-width: 100px;
  }
  [class$="filter-wrapper"] {
    min-width: 80px;
    max-width: fit-content;
  }
}
.btn-filter {
  background: #bb0a30 !important;
  color: #fff !important;
}
.confirmed-btn {
  background: transparent;
  border: 1px solid #000;
  color: #000;
  padding: 0.5rem;
}
</style>
<style>
.btn-enter,
.btn-download {
  padding: 1rem;
  background: #000;
  color: #fff;
  border: none;
  border-radius: 0px;
}
.btn-enter:hover {
  color: #ffff;
}
.inside-table .modal-container {
  max-width: 40vw !important;
}
.inside-table .controls {
  display: flex;
  justify-content: end;
  align-items: center;
}
.inside-table .controls .cancel-btn,
.inside-table .controls .continue {
  cursor: pointer;
}
.bolded {
  font-weight: bold !important;
}
.modal-alert .modal-container {
  max-width: 20vw !important;
}
.VueTables .dropdown {
  display: none !important;
}
.continue {
  border: none;
  background: transparent;
}
</style>
